import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import * as React from "react";
import { cn } from "../lib/utils";

export type SortDirection = "asc" | "desc";

interface SortableColumnHeaderProps {
  /** Label rendered in the header. */
  children: React.ReactNode;
  /** Whether this column is currently the active sort column. */
  active: boolean;
  /** Current sort direction, used to pick the arrow icon. */
  direction: SortDirection;
  onClick: () => void;
  className?: string;
}

function SortableColumnHeader({
  children,
  active,
  direction,
  onClick,
  className,
}: SortableColumnHeaderProps) {
  const Icon = !active ? ArrowUpDown : direction === "asc" ? ArrowUp : ArrowDown;
  // Sort state is otherwise conveyed only visually (via the aria-hidden arrow
  // icon). Append a visually-hidden status span so the accessible name becomes
  // e.g. "Name, sorted ascending" / "Name, not sorted" for screen-reader users.
  // WCAG 1.3.1 / 4.1.2.
  const sortState = !active
    ? ", not sorted"
    : direction === "asc"
      ? ", sorted ascending"
      : ", sorted descending";
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn("inline-flex cursor-pointer items-center gap-1 text-sm font-medium", className)}
    >
      {children}
      <span className="sr-only">{sortState}</span>
      <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden />
    </button>
  );
}

export { SortableColumnHeader };
export type { SortableColumnHeaderProps };
